import { Injectable } from '@angular/core';
import { Observable, of } from 'rxjs';
import { HttpClient, HttpErrorResponse } from '@angular/common/http';
import { AuthguardsGateway } from '@cigna/evernorth-member/shared/gateways-data-access';
import { LoggingService } from '@cigna/shared/angular/logging-util';
import { catchError, map } from 'rxjs/operators';
import { AuthParam, AuthGuardsResponse } from '../../interfaces';

@Injectable({
  providedIn: 'root',
})
export class AuthguardsService {
  constructor(
    private _http: HttpClient,
    private _gateway: AuthguardsGateway,
    private _logger: LoggingService,
  ) {}

  getAuthguards(
    param: AuthParam,
    isLd?: boolean,
  ): Observable<Record<string, boolean>> {
    return this._http
      .get<AuthGuardsResponse>(this._gateway.authguardsUrl(param, isLd))
      .pipe(
        map(({ authGuards }) =>
          authGuards.reduce(
            (acc, curr) => ({
              ...acc,
              [curr]: true,
            }),
            {},
          ),
        ),
        catchError((e: HttpErrorResponse) => {
          this._logger.error(e, 'error retrieving authguard data');

          return of({});
        }),
      );
  }
}
